export default {
  title: 'Drucker Einstellungen',
  sections: {
    destination: 'Belege drucken auf',
  },
  printers: {
    inner: {
      title: 'Integrierter Drucker',
    },
    external: {
      title: 'Externer Drucker',
      width_unset: 'Papierbreite nicht festgelegt',
      connect_hint: 'Drucker verbinden, um ihn zu nutzen',
      disconnect_confirm: 'Diesen Drucker trennen?',
      disconnect_confirm_description: 'Du musst ihn danach neu einrichten.',
      disconnect_confirm_ok: 'Ja, trennen',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Bereit',
      title: 'Bereit zum Drucken',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Papier fast leer',
      title: 'Papier ist fast leer',
      description: 'Rolle bald ersetzen. Der Druck läuft weiter.',
    },
    busy: {
      label: 'Beschäftigt',
      title: 'Drucker ist beschäftigt',
      description: '{{name}} beendet gerade einen anderen Auftrag.',
    },
    not_configured: {
      label: 'Nicht eingerichtet',
      title: 'Nicht eingerichtet',
      description: '{{name}} muss eingerichtet werden, bevor gedruckt werden kann.',
    },
    offline: {
      label: 'Offline',
      title: 'Kein Druck',
      description: '{{name}} ist offline. Neue Bestellungen werden nicht gedruckt.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} ist nicht verbunden.',
    },
    cover_open: {
      label: 'Deckel offen',
      title: 'Deckel ist offen',
      description: 'Deckel schließen, um den Druck fortzusetzen.',
    },
    paper_empty: {
      label: 'Kein Papier',
      title: 'Kein Papier',
      description: 'Rolle ersetzen, um den Druck fortzusetzen.',
    },
    wrong_paper: {
      label: 'Falsches Papier',
      title: 'Falsches Papier',
      description: 'Die eingelegte Rolle passt nicht zur eingestellten Papierbreite.',
    },
    cutter_error: {
      label: 'Schneidefehler',
      title: 'Schneidefehler',
      description: 'Schneidevorrichtung auf verklemmtes Papier prüfen und erneut versuchen.',
    },
    overheat: {
      label: 'Zu heiß',
      title: 'Drucker zu heiß',
      description: '{{name}} abkühlen lassen, bevor wieder gedruckt wird.',
    },
    error: {
      label: 'Fehler',
      title: 'Druckerfehler',
      description: '{{name}} hat einen Fehler gemeldet und braucht Aufmerksamkeit.',
    },
    connecting: {
      label: 'Verbinden…',
      title: 'Verbinden…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Nicht verbunden',
      title: 'Nicht verbunden',
      description: '{{name}} ist nicht verbunden.',
    },
  },
  form: {
    auto_print: {
      label: 'Neue Bestellungen automatisch drucken',
      not_ready: 'Automatischer Druck ist an, aber der externe Drucker ist nicht bereit. Es wird nicht gedruckt.',
    },
    print_copies: {
      label: 'Kopien pro Bestellung',
      hint: 'Automatischen Druck einschalten, um Kopien festzulegen',
      decrease: 'Kopien verringern',
      increase: 'Kopien erhöhen',
    },
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
  },
  buttons: {
    test_print: 'Test drucken',
    configure_external: 'Einrichten',
    connect_external: 'Drucker verbinden',
    disconnect_external: 'Trennen',
    retry_connection: 'Verbindung erneut versuchen',
    cancel: 'Abbrechen',
  },
};
